export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_09.64a036ed.jpg";